import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Typography } from '@mui/material';
import ChevronRightRounded from '@mui/icons-material/ChevronRightRounded';
import PlaceRounded from '@mui/icons-material/PlaceRounded';
import RouteRounded from '@mui/icons-material/RouteRounded';
import { ROUTES } from 'constants/RoutePaths';
import { buildRoutePath } from 'utils/utility';
import { useGetTrailListQuery } from 'app/api/trailApiSlice';
import { MLSearchInput } from 'components/common/SearchInput/SearchInput';
import './TrailHome.module.scss';

// One letter matches the start of a Trail's name; more match anywhere in
// its name or its Park's.
const matchesSearch = (trail, search) => {
  if (!search) return true;
  const s = search.toLowerCase();
  if (s.length === 1) return trail.trailname?.toLowerCase().startsWith(s);
  return (
    trail.trailname?.toLowerCase().includes(s) ||
    trail.parkname?.toLowerCase().includes(s)
  );
};

const formatDistance = (meters) =>
  meters >= 1000 ? `${(meters / 1000).toFixed(1)} km` : `${meters} m`;

// Every Trail, searchable by name or Park, each a link to its page.
const TrailHome = () => {
  const { data: trails = [], isLoading, error } = useGetTrailListQuery();
  const [search, setSearch] = useState('');

  if (isLoading) return <div className="ts-page">Loading...</div>;
  if (error) return <div className="ts-page">Error loading trails.</div>;

  const shown = trails.filter((trail) => matchesSearch(trail, search));

  return (
    <div className="ts-page flex flex-col gap-4">
      <Typography variant="h2">Find a trail</Typography>
      <MLSearchInput
        placeholderText="Search by trail or park"
        setSearchChange={setSearch}
        searchValue={search}
      />
      {shown.length === 0 ? (
        <Typography variant="body1" color="text.secondary">
          No trails found. Try a shorter search.
        </Typography>
      ) : (
        <ul className="ts-trail-list">
          {shown.map((trail) => (
            <li key={trail.trailid}>
              <Link
                className="ts-trail-row"
                to={`/${buildRoutePath(ROUTES.TRAIL_DETAIL, {
                  trailId: trail.trailid,
                })}`}
              >
                <span className="ts-trail-row__text">
                  <span className="ts-trail-row__name">{trail.trailname}</span>
                  <span className="ts-trail-row__facts">
                    <span>
                      <PlaceRounded aria-hidden="true" />
                      {trail.parkname}
                    </span>
                    {trail.distancemeters > 0 && (
                      <span>
                        <RouteRounded aria-hidden="true" />
                        {formatDistance(trail.distancemeters)}
                      </span>
                    )}
                  </span>
                </span>
                <ChevronRightRounded
                  className="ts-trail-row__chevron"
                  aria-hidden="true"
                />
              </Link>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default TrailHome;
